import React, { useContext } from "react";
import classNames from 'classnames';

import { ListingAppContext } from "../contexts";
import { ListingListItem } from "./ListItem";

export const ListingList = ({
  listings,
  filter,
  noItemsText,
  className,
  loading = false
}) => {
  const { t } = useContext(ListingAppContext)

  if (!listings.length) {
    return (
      <div className='listing-no-items'>
        {!!filter && (
          <>
            {t('result_not_found', { filter })}
            <br/>
            {t('try_another_search')}
          </>
        )}

        {!filter && (noItemsText || t('no_upcoming_events'))}
      </div>
    )
  }

  return (
    <div className={classNames('listing-items__wrapper', className)}>
      {listings.map((listing, index) => (
          <ListingListItem
            key={index}
            listing={listing}
            loading={loading}
          />
      ))}
    </div>
  );
}
